module.exports = __webpack_public_path__ + "img/line-arrow.32a45f50.png";